import * as React from 'react'

export const PendulumCircle = (props: React.ComponentProps<'svg'>) => (
    <svg id="Logo" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 200" {...props}>
        <rect  fill ="#32253e" x="0" y="0" width="200" height="200" rx="100" ry="100"/>
        <g>
            <path fill ="#dae9eb" d="m103.76,38.28c-26.77-.46-49.67,21.41-50.29,48.18-.46,18.17,8.9,34.18,23.11,43.13.67.41,1.6.15,1.96-.57l11.12-22.18c1.65-3.24,1.39-7.15-.62-10.19-1.7-2.63-2.68-5.76-2.63-9.11.1-8.65,6.95-15.8,15.54-16.27,9.93-.51,18.12,7.77,17.35,17.76-.62,8.03-7.1,14.46-15.08,15.13h-.15c-3.65.26-6.9,2.37-8.54,5.66l-11.12,22.13c-.36.72,0,1.6.72,1.85,5.61,2.16,11.68,3.29,18.07,3.29,27.02-.15,49.11-22.34,49.11-49.36.05-27.02-21.62-49-48.54-49.47Z"/>
            <circle fill ="#dae9eb" cx="69.94" cy="153.58" r="16.47"/>
        </g>
    </svg>
)